import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, forkJoin } from 'rxjs';
import { catchError, map, switchMap, mergeMap } from 'rxjs/operators';
import { EquipmentProjectService } from '@/core/services/equipment-project.service';
import {
  loadEquipmentProjectsByProject,
  loadEquipmentProjectsByProjectSuccess,
  loadEquipmentProjectsByProjectFailure,
  addEquipmentProjects,
  addEquipmentProjectsSuccess,
  addEquipmentProjectsFailure,
  updateEquipmentProject,
  updateEquipmentProjectSuccess,
  updateEquipmentProjectFailure,
  deleteEquipmentProject,
  deleteEquipmentProjectSuccess,
  deleteEquipmentProjectFailure,
} from './equipment-project.actions';

@Injectable()
export class EquipmentProjectEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(EquipmentProjectService);

  loadByProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEquipmentProjectsByProject),
      switchMap(({ projectId }) =>
        this.service.getByProjectId(projectId).pipe(
          map(items => {
            console.log('Loaded equipment projects:', items);
            return loadEquipmentProjectsByProjectSuccess({ items, projectId });
          }),
          catchError(error => of(loadEquipmentProjectsByProjectFailure({ error })))
        )
      )
    )
  );

  addMultiple$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addEquipmentProjects),
      mergeMap(({ items }) =>
        forkJoin(items.map(item => this.service.add(item))).pipe(
          map(created => addEquipmentProjectsSuccess({ items: created })),
          catchError(error => of(addEquipmentProjectsFailure({ error })))
        )
      )
    )
  );

  update$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateEquipmentProject),
      mergeMap(({ item }) =>
        this.service.update(item).pipe(
          map(updated => updateEquipmentProjectSuccess({ item: updated })),
          catchError(error => of(updateEquipmentProjectFailure({ error })))
        )
      )
    )
  );

  delete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteEquipmentProject),
      mergeMap(({ id }) =>
        this.service.delete(id).pipe(
          map(() => deleteEquipmentProjectSuccess({ id })),
          catchError(error => of(deleteEquipmentProjectFailure({ error })))
        )
      )
    )
  );
}
